import request from '@/utils/request'

/**
 * 查询店铺访问记录
 * @param {Object} params 查询参数
 * @returns {Promise} Promise对象
 */
export function queryShopVisit(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/shopVisit.queryShopVisit',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}